import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRoute } from '@nuxtjs/composition-api'
import { IMPACT_SECTION_IDS } from '~/constants/impactSectionIds'
import { hasCarryRemarks } from '~/functions/impact-carry-kpi'
import { useImpactEditContext } from '~/functions/useImpactEditContext'
import type { ImpactSectionBindingOptions } from '~/functions/impact-section-bindings'
import {
  type ImpactGoalType,
  TemplateEngineContext,
} from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'impactCarry',
  props: {
    impactGoal: null,
    impact: null
  },
  setup(__props: any) {

const props = __props as {
  impactGoal: ImpactGoalType
  impact?: Record<string, unknown>
};



const route = useRoute()
const { impact, impactEditable, accountId, impactGoal } = useImpactEditContext(props)

const validateStartingYear = (val: unknown): boolean | string => {
  if (val === null || val === undefined || val === '') return true
  const normalized = String(val).trim()
  return /^\d{4}$/.test(normalized) ? true : 'Please enter a 4-digit year (YYYY).'
}

const carryBindingOverrides: ImpactSectionBindingOptions = {
  validatorByIxId: {
    startingYear: validateStartingYear,
  },
}

const showCarryRemarks = computed(() =>
  hasCarryRemarks(impact.value?.carryRemarks),
)

const carryRemarksBindings = {
  carryRemarks: 'string' as const,
}

const evidenceHeaders = [
  { value: 'actions', width: '30px' },
  { value: 'description', text: 'Key Insights' },
  { value: 'evidence', width: '200px', text: 'Evidence' },
]

const evidenceQuery = computed(() => ({
  accountId: route.params.venture,
  entityIntIds: impact.value?.id ? [impact.value.id] : [],
  type: 'impact',
}))

return { __sfc: true,props, route, impact, impactEditable, accountId, impactGoal, validateStartingYear, carryBindingOverrides, showCarryRemarks, carryRemarksBindings, evidenceHeaders, evidenceQuery, IMPACT_SECTION_IDS, TemplateEngineContext }
}

})